import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/common/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import PasswordGenerator from "./pages/PasswordGenerator";
import SavePassword from "./pages/SavePassword";
import CreateGroup from "./pages/CreateGroup";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import TermsOfService from "./pages/TermsOfService";
import ArticlesPage from "./pages/ArticlesPage";
import Article from "./pages/Article";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/generator" element={<PasswordGenerator />} />
            <Route path="/save-password" element={<SavePassword />} />
            <Route path="/create-group" element={<CreateGroup />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/articles/:id" element={<Article />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
